import { render, staticRenderFns } from "./SkipQuestions.vue?vue&type=template&id=60af2a8e&"
import script from "./SkipQuestions.vue?vue&type=script&lang=js&"
export * from "./SkipQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports